// import { makeStyles, Theme } from '@material-ui/core/styles';

// export const useStyles = makeStyles((theme: Theme) => ({
//   root: {
//     display: 'flex',
//   },
//   title: {
//     flexGrow: 1,
//     margin: theme.spacing(1),
//   },
//   content: {
//     flexGrow: 1,
//     height: '100vh',
//     overflow: 'auto',
//     paddingTop: theme.spacing(8),
//   },
//   container: {
//     paddingTop: 8,
//     paddingBottom: 32,
//   },
//   paper: {
//     display: 'flex',
//     justifyContent: 'center',
//     justifyItems: 'center',
//     flexDirection: 'column',
//     background: 'transparent',
//     boxShadow: theme.shadows[0],
//   },
//   fixedHeight: {
//     height: 240,
//   },
//   margin: {
//     margin: theme.spacing(1),
//   },
//   search: {
//     margin: theme.spacing(2, 0),
//     background: ' #ffffff',
//   },
// }));
import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  label: {
    minWidth: 'auto',
    maxWidth: 'inherit',
    padding: 0,
    fontWeight: 500,
    fontSize: 14,
  },
  title: {
    flexGrow: 1,
    fontSize: 14,
    margin: theme.spacing(1),
  },
  gridPaper: {
    height: '100%',
  },
  tabsPaper: {
    width: '100%',
    boxShadow: theme.shadows[0],
    backgroundColor: 'transparent',
    '& [class*="MuiBox-root"]': {
      padding: theme.spacing(2, 0, 0, 0),
    },
  },
  tabsPanel: {
    padding: 12,
    width: '100%',
  },
  tabBox: {
    //backgroundColor: '#ffffff',
    //marginTop: theme.spacing(2.5),
  },
  tab: {
    //backgroundColor: '#ffffff',
    marginTop: theme.spacing(2.5),
  },
  container: {
    width: '100%',
  },
  row: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: theme.spacing(3.5),
  },
  titlePopSmtp: {
    width: 170,
    margin: theme.spacing(0, 5, 0, 0),
    color: 'rgb(0 0 0 / 87%)',
  },
  desc: {
    width: 320,
    borderBottom: '1px solid #E0E0E0',
    padding: 5,
    color: 'rgb(0 0 0 / 87%)',
  },
  tabs: {
    width: 'fit-content',
    border: '1px solid white',
    borderRadius: '4px 0px 0px 4px',
    background: 'white',
    '& .MuiTabs-indicator': {
      backgroundColor: 'orange',
      height: 3,
    },
    '& .MuiTab-root.Mui-selected': {
      color: 'white',
      backgroundColor: '#5081FF',
    },
    '& .MuiTab-root': {
      padding: '16px 24px',
    },
  },
}));
